import {type FC, useEffect, useMemo, useState} from 'react';
import MultiSelect, {type Option} from '@/components/common/forms/MultiSelect';
import type {Species} from '@/domain/entities/Species';

type Props = {
  species: Species[];
  onSelectionChange: (uuids: string[]) => void;
};

const SpeciesSelector: FC<Props> = ({species, onSelectionChange}) => {
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);

  const options = useMemo(() => {
    return species.map((specie) => ({
      id: specie.uuid,
      label: specie.nameKey,
    }));
  }, [species]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: not needed
  useEffect(() => {
    onSelectionChange(selectedOptions.map((option) => option.id));
  }, [selectedOptions]);

  return (
    <MultiSelect
      placeholder={'Especies'}
      options={options}
      selectedOptions={selectedOptions}
      onOptionsChanged={setSelectedOptions}
    />
  );
};

export default SpeciesSelector;
